import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "今日热瓜", href: "#hot" },
  { label: "话题库", href: "#topics" },
  { label: "逐帧现场", href: "#scene" },
  { label: "证据对比", href: "#evidence" },
  { label: "人物档案", href: "#archive" },
  { label: "常见问题", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-200))]"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-6 h-16 max-w-[1320px] mx-auto">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-primary-500 text-background-50">
            <i className="ri-eye-2-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-bold text-lg text-foreground-950">
              海外吃瓜
            </span>
            <span className="font-latin tracking-[0.2em] text-[10px] text-primary-600">
              SCOOP HUB
            </span>
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-7">
          {NAV_ITEMS.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-900 whitespace-nowrap">
            <i className="ri-flashlight-fill text-accent-500"></i>
            24h 更新 · 37 起新事件
          </span>
          <a
            href="#contact"
            className="rounded-full bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            我要爆料
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          className="lg:hidden flex items-center justify-center w-10 h-10 rounded-lg text-foreground-900 cursor-pointer"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 pb-4">
          <ul className="flex flex-col pt-2">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block py-3 text-sm font-medium text-foreground-800 hover:text-primary-600 border-b border-background-100"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap"
          >
            <i className="ri-message-3-line"></i>我要爆料
          </a>
        </div>
      )}
    </header>
  );
}